module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-without-heading",
    attrs: {
      "epub:type": "epigraph",
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left epigraph-content"
  }, [_vm._v("‘Look before you, lady. Look at that dark water. How many times do you read of such as I who spring into the tide, and leave no living thing, to care for, or bewail them. It may be years hence, or it may be only months, but I shall come to that at last.’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left epigraph-content"
  }, [_vm._v("— Charles Dickens, "), _c('i', [_vm._v("Oliver Twist")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08274547","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 75
// module chunks = 0